import { ListingWizardForm } from '@/modules/cars/components/listing/listing-wizard-form'

export function DealerCreateCarPage() {
  return (
    <div className="py-4 space-y-6">
      <h1 className="font-display text-2xl font-bold tracking-tight">Add Vehicle to Inventory</h1>
      <ListingWizardForm redirectPath="/dealer/cars" />
    </div>
  )
}
